import { Translatable } from '@app/types/translatable.type';

export const StatusDisplayOptions: { [key: string]: Translatable } = {
    pending: 'applicant-tracker.pending',
    passed: 'applicant-tracker.passed',
    failed: 'applicant-tracker.failed',
};
